export default "__VITE_ASSET__CExBiiXO__"